export default __webpack_public_path__ + "static/media/2182.f17e525a.png";